import {useEagGridSelector} from '../useEagGridSelector';
import {selectCanCopyColumn} from './selectCanCopyColumn';

export function useCanCopyColumn(columnKey: string): boolean {
  return useEagGridSelector((state) => selectCanCopyColumn(state, columnKey));
}
